import styled from 'styled-components';
import { MapTableWrapper } from 'components/mapContactProperties/styles';

export const MatchedTableContainer = styled(MapTableWrapper)`
  .ant-table-scroll table {
    width: auto !important;
  }
`;
